<template>
            <nav id="app-sidebar" :class="{ 'sidebar-open': mobileSidebarOpen }">

                <!-- Brand -->
                <div class="sidebar-brand">
                    <div class="sidebar-brand-icon" v-if="!branding.headerLogoUrl">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                        </svg>
                    </div>
                    <img v-else :src="branding.headerLogoUrl" alt="logo" style="width:28px;height:28px;object-fit:contain;border-radius:6px;background:#fff;padding:3px;" />
                    <div class="sidebar-brand-text">
                        <div class="sidebar-brand-name">{{ branding.headerTitle || 'AI Mail Console' }}</div>
                        <div class="sidebar-brand-sub">郵件管理平台</div>
                    </div>
                </div>

                <!-- Navigation -->
                <div class="sidebar-nav">

                    <!-- ── 工作區 ── -->
                    <div class="sidebar-section-label">工作區</div>

                    <button type="button" @click.prevent="openWebmailHome()"
                        :class="currentView === 'webmail' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                        </svg>
                        我的信箱
                    </button>

                    <!-- Mail sub-folders (shown when in webmail) -->
                    <div v-if="currentView === 'webmail'" class="sidebar-sub">
                        <button type="button" @click.prevent="openWebmailFolder('INBOX')"
                            :class="(currentView === 'webmail' && currentFolder === 'INBOX') ? 'active' : ''"
                            class="sidebar-item">
                            <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>
                            收件匣
                            <span v-if="(folderUnreadCounts?.['INBOX'] ?? 0) > 0"
                                class="sidebar-badge" style="margin-left:auto;background:#ef4444;color:#fff;">
                                {{ folderUnreadCounts['INBOX'] > 99 ? '99+' : folderUnreadCounts['INBOX'] }}
                            </span>
                        </button>
                        <button type="button" @click.prevent="openWebmailFolder('Sent')"
                            :class="(currentView === 'webmail' && currentFolder === 'Sent') ? 'active' : ''"
                            class="sidebar-item">
                            <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                            已寄出
                        </button>
                        <button type="button" @click.prevent="openScheduledCampaignList()"
                            class="sidebar-item">
                            <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                            排程信件
                        </button>
                        <button type="button" @click.prevent="openWebmailFolder('Trash')"
                            :class="(currentView === 'webmail' && currentFolder === 'Trash') ? 'active' : ''"
                            class="sidebar-item">
                            <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                            垃圾桶
                        </button>
                        <button type="button" @click.prevent="openWebmailFolder('Junk')"
                            :class="(currentView === 'webmail' && currentFolder === 'Junk') ? 'active' : ''"
                            class="sidebar-item">
                            <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                            垃圾信
                            <span v-if="(folderUnreadCounts?.['Junk'] ?? 0) > 0"
                                class="sidebar-badge" style="margin-left:auto;background:#f97316;color:#fff;">
                                {{ folderUnreadCounts['Junk'] > 99 ? '99+' : folderUnreadCounts['Junk'] }}
                            </span>
                        </button>
                    </div>

                    <button v-if="canAccess('contacts')" type="button" @click.prevent="switchSidebarView('contacts')"
                        :class="currentView === 'contacts' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                        聯絡人管理
                    </button>

                    <button v-if="canAccess('contacts')" type="button" @click.prevent="switchSidebarView('crm')"
                        :class="currentView === 'crm' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 8h10"/><path d="M7 12h6"/></svg>
                        客戶 CRM
                    </button>

                    <button v-if="canAccess('invoice_drive')" type="button" @click.prevent="switchSidebarView('invoice_drive')"
                        :class="currentView === 'invoice_drive' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                        發票專區
                    </button>

                    <button v-if="canAccess('secure_portal')" type="button" @click.prevent="switchSidebarView('secure_portal')"
                        :class="currentView === 'secure_portal' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                        安全信件
                    </button>


                    <button v-if="canAccess('ai_sales')" type="button" @click.prevent="openAiSalesView()"
                        :class="currentView === 'ai_sales' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                        AI 業務助手
                    </button>

                    <!-- ── 分析與洞察 ── -->
                    <div class="sidebar-section-label" style="margin-top:0.75rem;">分析與洞察</div>

                    <button v-if="canAccess('dashboard')" type="button" @click.prevent="setCurrentView('dashboard')"
                        :class="currentView === 'dashboard' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
                        儀表板
                    </button>

                    <button v-if="canAccess('rag_chat')" type="button" @click.prevent="setCurrentView('rag_chat')"
                        :class="currentView === 'rag_chat' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                        企業知識庫
                    </button>

                    <!-- ── AI 行銷 ── -->
                    <div class="sidebar-section-label" style="margin-top:0.75rem;">AI 行銷</div>

                    <button v-if="canAccess('marketing_center') || canAccess('marketing_journey')" type="button" @click="openMarketingContent()"
                        :class="showAiMarketingModal ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                        AI 智能行銷中心
                    </button>


                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('marketing_report')"
                        :class="currentView === 'marketing_report' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
                        行銷追蹤報表
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('landing_page')"
                        :class="currentView === 'landing_page' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                        行銷推廣頁面
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('survey')"
                        :class="currentView === 'survey' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1" ry="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></svg>
                        問卷調查中心
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('pref_center')"
                        :class="currentView === 'pref_center' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                        訂閱偏好中心
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('booking')"
                        :class="currentView === 'booking' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                        預約連結管理
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('report_schedule')"
                        :class="currentView === 'report_schedule' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                        報表排程寄送
                    </button>

                    <button v-if="canAccess('marketing_center')" type="button" @click.prevent="switchSidebarView('marketing_calendar')"
                        :class="currentView === 'marketing_calendar' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                        行銷行事曆
                    </button>

                    <!-- ── AI 小幫手統計 ── -->
                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('support_stats')"
                        :class="currentView === 'support_stats' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        客服問題統計
                    </button>

                    <!-- ── 帳號管理 ── -->
                    <div v-if="isSuperAdmin || isDomainAdmin" class="sidebar-section-label" style="margin-top:0.75rem;">帳號管理</div>

                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('domains')"
                        :class="currentView === 'domains' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
                        網域管理
                    </button>

                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('users')"
                        :class="currentView === 'users' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                        使用者管理
                    </button>

                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('departments')"
                        :class="currentView === 'departments' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        部門管理
                    </button>

                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('groups')"
                        :class="currentView === 'groups' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                        群組管理
                    </button>

                    <button v-if="isSuperAdmin || isDomainAdmin" type="button" @click.prevent="switchSidebarView('branding')"
                        :class="currentView === 'branding' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                        外觀設定
                    </button>

                    <!-- ── 伺服器管理 ── -->
                    <div v-if="isSuperAdmin" class="sidebar-section-label" style="margin-top:0.75rem;">伺服器管理</div>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('server_mail')"
                        :class="currentView === 'server_mail' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"/><rect x="2" y="14" width="20" height="8" rx="2" ry="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>
                        郵件服務
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('server_dns')"
                        :class="currentView === 'server_dns' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6l11 6 11-6M1 12l11 6 11-6"/></svg>
                        DNS 服務
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('server_db')"
                        :class="currentView === 'server_db' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>
                        資料庫
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('server_ai')"
                        :class="currentView === 'server_ai' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                        AI 服務
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('mail_queue')"
                        :class="currentView === 'mail_queue' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                        郵件佇列
                    </button>

                    <!-- ── 寄件審核 ── -->
                    <button v-if="canAccess('mail_queue')" type="button" @click.prevent="switchSidebarView('outgoing_approval')"
                        :class="currentView === 'outgoing_approval' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4"/><path d="M21 12c0 4.97-4.03 9-9 9S3 16.97 3 12 7.03 3 12 3s9 4.03 9 9z"/></svg>
                        寄件審核
                        <span v-if="outgoingApprovalPendingCount > 0" class="badge badge-warning" style="margin-left:auto;">{{ outgoingApprovalPendingCount }}</span>
                    </button>

                    <!-- ── 郵件安全 ── -->
                    <div v-if="isSuperAdmin || isDomainAdmin" class="sidebar-section-label" style="margin-top:0.75rem;">郵件安全</div>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('security_filter')"
                        :class="currentView === 'security_filter' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                        過濾與稽核
                    </button>

                    <!-- 個人過濾規則：暫停使用，隱藏入口 -->
                    <!-- <button type="button" @click.prevent="switchSidebarView('sieve_filter')"
                        :class="currentView === 'sieve_filter' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><polyline points="3 6 4 7 6 5"/><polyline points="3 12 4 13 6 11"/><polyline points="3 18 4 19 6 17"/></svg>
                        個人過濾規則
                    </button> -->

                    <button v-if="canAccess('mail_audit_records')" type="button" @click.prevent="switchSidebarView('mail_audit_records')"
                        :class="currentView === 'mail_audit_records' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                        郵件稽核
                    </button>

                    <div v-if="currentView === 'mail_audit_records'" class="sidebar-sub">
                        <button type="button" @click.stop.prevent="switchSidebarView('mail_audit_records')" class="sidebar-item">進出郵件紀錄</button>
                        <button type="button" @click="openSecurityQuarantine('phishing')" class="sidebar-item">AI 詐騙隔離區</button>
                        <button type="button" @click="openSecurityQuarantine('spam')" class="sidebar-item">垃圾郵件隔離區</button>
                        <button type="button" @click="switchSidebarView('security_audit')" class="sidebar-item">操作稽核</button>
                    </div>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('security_wizard')"
                        :class="currentView === 'security_wizard' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                        安全性設定
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('server_ssl')"
                        :class="currentView === 'server_ssl' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
                        SSL 憑證
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('log_analysis')"
                        :class="currentView === 'log_analysis' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                        日誌分析
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('logs')"
                        :class="currentView === 'logs' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                        郵件日誌
                    </button>

                    <!-- ── 系統設定 ── -->
                    <div v-if="isSuperAdmin" class="sidebar-section-label" style="margin-top:0.75rem;">系統設定</div>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('backup_settings')"
                        :class="currentView === 'backup_settings' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>
                        備份管理
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('tenant_management')"
                        :class="currentView === 'tenant_management' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                        多租戶管理
                    </button>

                    <button v-if="isSuperAdmin" type="button" @click.prevent="switchSidebarView('alert_center')"
                        :class="currentView === 'alert_center' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                        告警中心
                        <span
                          v-if="alertSummary.danger > 0"
                          class="sidebar-badge"
                          style="background:var(--color-danger);color:#fff;margin-left:auto;"
                        >{{ alertSummary.danger }}</span>
                        <span
                          v-else-if="alertSummary.warning > 0"
                          class="sidebar-badge"
                          style="background:var(--color-warning);color:#fff;margin-left:auto;"
                        >{{ alertSummary.warning }}</span>
                    </button>

                </div><!-- end sidebar-nav -->

                <!-- Sidebar Footer: User Info + Logout -->
                <div class="sidebar-footer">
                    <div class="sidebar-user">
                        <div class="sidebar-avatar">{{ (currentUser?.email || 'U')[0].toUpperCase() }}</div>
                        <div class="sidebar-user-info">
                            <div class="sidebar-user-email">{{ currentUser?.email }}</div>
                            <div class="sidebar-user-role">{{ roleLabel }}</div>
                        </div>
                    </div>
                    <button type="button" @click.prevent="switchSidebarView('profile')"
                        :class="currentView === 'profile' ? 'active' : ''"
                        class="sidebar-item">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>
                        個人設定
                    </button>
                    <button @click="logout" class="sidebar-item" style="color:rgba(239,68,68,0.8);width:calc(100% - 0px);margin:0;">
                        <svg class="sidebar-item-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                        登出系統
                    </button>
                </div>
            </nav><!-- end sidebar -->

</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useAppStore } from '../store/app.js'

const store = useAppStore()
const {
  currentView, branding, currentUser, isSuperAdmin, isDomainAdmin,
  roleLabel, webmailTab, currentFolder, showAiMarketingModal, aiMarketingState,
  outgoingApprovalPendingCount, alertSummary, mobileSidebarOpen,
  folderUnreadCounts,
} = storeToRefs(store)

const {
  switchSidebarView, canAccess, logout, setCurrentView,
  openWebmailHome, openWebmailFolder, openWebmailCalendar,
  openAiSalesView, openLineSupportView,
  openMarketingJourney, openMarketingContent,
  openSecurityQuarantine, closeMobileSidebar,
  openScheduledCampaignList,
} = store
</script>
